/* eslint-disable no-inner-declarations */

// Object.groupBy is available in Safari 17.4+
const hasGroupBy = typeof Object.groupBy !== typeof undefined;

if (!hasGroupBy) {
  function groupBy<T, K extends PropertyKey>(
    arr: readonly T[],
    callback: (item: T, index: number, array: readonly T[]) => K
  ): Record<K, T[]> {
    return arr.reduce((acc, item, index, array) => {
      const key = callback(item, index, array);

      acc[key] ??= [];
      acc[key].push(item);

      return acc;
    }, {} as Record<K, T[]>);
  }

  if (typeof Object.groupBy === typeof undefined) {
    Object.groupBy = groupBy;
  }
}
